import { fetchParkings, fetchParking, removeParking } from '../repositories/parking.repository'

const state = {
    parkings: [],
    parking: null
}

const actions = {
    fetchParkings ({ commit }, fields = null) {
        return new Promise(resolve => fetchParkings(fields)
            .then(res => {
                commit('setParkings', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
    fetchParking ({ commit }, id) {
        return new Promise(resolve => fetchParking(id)
            .then(res => {
                commit('setParking', res.data)
                resolve()
            })
            .catch(error => console.log(error)))
    },
    /* eslint-disable no-unused-vars */
    removeParking ({ dispatch }, id) {
        return removeParking(id)
    }
}

const mutations = {
    setParkings (state, parkings) {
        state.parkings = parkings
    },
    setParking (state, parking) {
        state.parking = parking
    }
}

const getters = {
    interbonParkings: (state) => {
        return state.parkings.filter(parking => !parking.isBokalParking);
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}